/**
 * Calls `stopPropagation()` on the passed event-like object.
 * @param e Event-like object.
 */
export const stopPropagation = (e: { stopPropagation: () => void }) => {
  e.stopPropagation();
};
